"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BorderWidth = void 0;
var react_1 = __importStar(require("react"));
var arrays_1 = require("utils/arrays");
var components_1 = require("../components");
var BorderWidth = function () { return (react_1.default.createElement(components_1.Section, { examples: react_1.default.createElement(react_1.Fragment, null, (0, arrays_1.range)(0, 3).map(function (val) { return (react_1.default.createElement("div", { className: "bdr".concat(val, " bdr-dark6 d-ib m1 p2 rnd"), key: val }, "bdr".concat(val))); })), id: "width", title: "Border width" })); };
exports.BorderWidth = BorderWidth;
